
const digest = '1171d1ea5ad8ac5ab70d9f6cea3ce3714679b878866b073ddf363b875a948491';
const classes = {"testForm":"_test-form_1dr1t_1"};
const css = `._test-form_1dr1t_1 {
  border: 1px solid blue;
  padding: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  